import { config } from '../../config';
import { HttpClient } from './httpClient';

export const apiClient = new HttpClient();
apiClient.defaultOptions = {
  baseUrl: config.apiBaseUrl,
};
